/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {PublicFrRoutes} from './PublicFrRoutes'
import {PublicGeRoutes} from './PublicGeRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'

import {SelectedWeekProvider} from '../contexts/SelectedWeekContext'
import {App} from '../App'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import { HomePage } from '../pages/home/HomePage'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter>
      <SelectedWeekProvider defaultWeek = '2024-W1'>
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            {currentUser ? (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
                <Route index element={<Navigate to='/dashboard' />} />
              </>
            ) : (
              <>
                <Route
                  path='/*'
                  element={<Navigate to='/fr/respiratory-sydroms-in-social-media' />}
                />
                <Route path='fr/*' element={<PublicFrRoutes />} />
                <Route path='ge/*' element={<PublicGeRoutes />} />

                <Route path='auth/*' element={<AuthPage />} />
                <Route
                  path='*'
                  element={<Navigate to='/fr/respiratory-sydroms-in-social-media' />}
                />
              </>
            )}
          </Route>
        </Routes>
      </SelectedWeekProvider>
    </BrowserRouter>
  )
}

export {AppRoutes}
